import { map, mapKeys, mapValues, omit } from 'lodash';
import {
  UPDATE_EDIT_ORG,
  START_EDIT_ORG,
  CANCEL_EDIT_ORG,
  UPDATE_ORG_INFO_SUCCESS,
  GET_ORG_MEMBERS_SUCCESS,
  UPDATE_USER_INFO_SUCCESS,
  LOGOUT_COMPLETE,
  DEACTIVATE_USER_SUCCESS,
  UPDATE_ORG_INFO_FAILURE,
  UPDATE_ORG_INFO_REQUEST,
  ACTIVATE_USER_SUCCESS,
  UPDATE_ORG_MEMBER_SUCCESS,
  GET_ORG_CUSTODIANS_SUCCESS,
  ADD_ORG_CUSTODIAN_SUCCESS,
  DELETE_ORG_CUSTODIAN_SUCCESS,
} from '../../constants/actionTypes';

const initialState = {
  currentValues: {},
  isEdit: false,
  orgMembers: {},
  orgCustodians: {},
};

export const orgsReducer = function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_EDIT_ORG:
      return {
        ...state,
        currentValues: {
          ...state.currentValues,
          [action.key]: action.value,
        },
      };

    case START_EDIT_ORG:
      return {
        ...state,
        isEdit: true,
        currentValues: {},
      };

    case UPDATE_ORG_INFO_SUCCESS:
    case CANCEL_EDIT_ORG:
      return {
        ...state,
        ...action,
        isEdit: false,
        currentValues: {},
      };

    case ACTIVATE_USER_SUCCESS:
    case DEACTIVATE_USER_SUCCESS: {
      const { receivedAt, result, requestInfo } = action;
      const members = map(result, (r) => omit(r, 'api_key'));
      const membersById = mapKeys(members, 'id');
      const newOrgMembers = {
        ...state.orgMembers,
        [requestInfo.orgId]: {
          lastFetched: receivedAt,
          membersById,
        },
      };

      return {
        ...state,
        orgMembers: newOrgMembers,
      };
    }

    case UPDATE_ORG_INFO_FAILURE:
      return {
        ...state,
        ...action,
      };

    case UPDATE_ORG_INFO_REQUEST:
      return {
        ...state,
        ...action,
      };

    case GET_ORG_MEMBERS_SUCCESS:
    case UPDATE_ORG_MEMBER_SUCCESS: {
      const { receivedAt, result, requestInfo } = action;
      const members = map(result, (r) => omit(r, 'api_key'));
      const membersById = mapKeys(members, 'id');
      const newOrgMembers = {
        ...state.orgMembers,
        [requestInfo.id]: {
          lastFetched: receivedAt,
          membersById,
        },
      };

      return {
        ...state,
        orgMembers: newOrgMembers,
      };
    }

    case GET_ORG_CUSTODIANS_SUCCESS:
    case ADD_ORG_CUSTODIAN_SUCCESS:
    case DELETE_ORG_CUSTODIAN_SUCCESS: {
      const { receivedAt, result, requestInfo } = action;
      const custodians = map(result, (r) => {
        return { ...r, custodian_type: 'org' };
      });
      const custodiansById = mapKeys(custodians, 'id');
      const newOrgCustodians = {
        ...state.orgCustodians,
        [requestInfo.orgId]: {
          lastFetched: receivedAt,
          custodiansById,
        },
      };

      return {
        ...state,
        orgCustodians: newOrgCustodians,
      };
    }

    case UPDATE_USER_INFO_SUCCESS: {
      const {
        result,
        entities: { users },
        receivedAt,
      } = action;
      const { orgMembers } = state;
      const user = users[result];
      const member = { ...user, user_status: user.status };
      delete member.org_memberships;

      const userOrgMembershipsById = mapKeys(user.org_memberships, 'id');
      const newOrgMembers = mapValues(orgMembers, (orgInfo, orgId) => {
        if (userOrgMembershipsById[orgId]) {
          const { membersById } = orgInfo;
          const orgMembership = userOrgMembershipsById[orgId];
          const orgMember = {
            ...member,
            'is_admin?': orgMembership['is_admin?'],
            access_role: orgMembership.access_role,
            org_membership_status: orgMembership.org_membership_status,
          };

          return {
            lastFetched: receivedAt,
            membersById: { ...membersById, [member.id]: orgMember },
          };
        }

        return orgInfo;
      });

      return {
        ...state,
        orgMembers: newOrgMembers,
      };
    }

    case LOGOUT_COMPLETE:
      return initialState;

    default:
      return state;
  }
};
